import { Suspense } from "react"
import { Card } from "react-bootstrap"
import { Outlet } from "react-router-dom"

const loading = () => <></>

const DefaultLayout = () => {
  return (
    <div className="bootstrap-scope">
      <div className="auth-fluid">
        <div className="auth-fluid-form-box">
          <div className="align-items-center d-flex h-100">
            <Card.Body>
              <Suspense fallback={loading()}>
                <Outlet />
              </Suspense>
            </Card.Body>
          </div>
        </div>
      </div>
    </div>
  )
}
export default DefaultLayout
